import { isConsoleDebugEnabled } from './consoleDebug';

/** Console auth tracing — only when `localStorage.tms_debug` is enabled. */
export const AUTH_DEBUG = isConsoleDebugEnabled();

export function logAuth(label: string, data?: Record<string, unknown>): void {
  if (!isConsoleDebugEnabled()) return;
  if (data !== undefined) {
    console.log(`[login-web auth] ${label}`, data);
  } else {
    console.log(`[login-web auth] ${label}`);
  }
}
